import React, { useState } from 'react';
import styled from 'styled-components';
import { FormField, Button, ButtonGroup } from './FormElements';

const FormContainer = styled.div`
  width: 100%;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  color: ${props => props.theme.colors.text};
`;

const Description = styled.p`
  margin-bottom: 2rem;
  line-height: 1.6;
  color: ${props => props.theme.colors.lightText};
`;

const TaxasScreen = ({ formData, updateFormData, nextStep, prevStep }) => {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    updateFormData({ [name]: value });

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formData.breve_descricao) {
      newErrors.breve_descricao = 'Conte brevemente sobre a empresa';
    }

    if (!formData.filiada_produtos_servicos) {
      newErrors.filiada_produtos_servicos = 'Descreva os produtos ou serviços oferecidos';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    nextStep();
  };

  return (
    <FormContainer>
      <Title>Conte sobre a empresa</Title>
      <Description>
        Compartilhe um resumo da atuação da empresa e destaque os principais produtos ou serviços oferecidos.
        Essas informações ajudam o SETIRN a direcionar os benefícios mais relevantes.
      </Description>

      <form onSubmit={handleSubmit}>
        <FormField
          label="Breve Descrição da Empresa"
          name="breve_descricao"
          type="textarea"
          placeholder="Fale sobre a história, foco de atuação ou diferenciais da empresa"
          value={formData.breve_descricao || ''}
          onChange={handleChange}
          error={errors.breve_descricao}
          rows={4}
        />

        <FormField
          label="Breve descricao dos produtos / servicos"
          name="filiada_produtos_servicos"
          type="textarea"
          placeholder="Liste os principais produtos, serviços ou tecnologias oferecidos"
          value={formData.filiada_produtos_servicos || ''}
          onChange={handleChange}
          error={errors.filiada_produtos_servicos}
          rows={4}
        />

        <ButtonGroup>
          <Button type="button" onClick={prevStep}>Voltar</Button>
          <Button type="submit" primary>Continuar</Button>
        </ButtonGroup>
      </form>
    </FormContainer>
  );
};

export default TaxasScreen;